export var BillingPeriod;
(function (BillingPeriod) {
    BillingPeriod["Monthly"] = "Monthly";
    BillingPeriod["Yearly"] = "Yearly";
})(BillingPeriod || (BillingPeriod = {}));
//# sourceMappingURL=billing-period.const.js.map